import { render } from "./_Avatar.vue?vue&type=template&id=278283c4&scoped=true"
import script from "./_Avatar.vue?vue&type=script&lang=js"
export * from "./_Avatar.vue?vue&type=script&lang=js"

import "@/css/chatbot.scss?vue&type=style&index=0&lang=scss"
import "./_Avatar.vue?vue&type=style&index=1&id=278283c4&lang=scss&scoped=true"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278283c4"]])

export default __exports__